const phoneRegex = /^(\d{1})?(\d{3})(\d{3})(\d{2})(\d{2})$/;

export const normalizePhone = (phone) => phone.replace(phoneRegex, '+7$2$3$4$5');

export const prettifyPhone = (phone) => phone.replace(phoneRegex, '+7 $2 $3 $4 $5');

export const prettifyPhoneWithCode = (phone) => phone.replace(phoneRegex, '+7 ($2) $3 $4 $5');
